// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconTrash.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconTrash = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M2.14286 15.0005C2.14286 15.5525 2.65429 16.0005 3.28571 16.0005H12.7143C13.3457 16.0005 13.8571 15.5525 13.8571 15.0005L14.8571 6.00049H1.14286L2.14286 15.0005Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.8571 2.00049H10.4286V1.00049C10.4286 0.448488 9.91714 0.000488281 9.28572 0.000488281H6.71429C6.08286 0.000488281 5.57143 0.448488 5.57143 1.00049V2.00049H1.14286C0.511429 2.00049 0 2.44849 0 3.00049V4.00049H16V3.00049C16 2.44849 15.4886 2.00049 14.8571 2.00049Z" />
  </BaseIcon>
);

export default IconTrash;
